import classNames from 'classnames';
import React from 'react';
import badge_completed from 'src/assets/images/badge_completed.png';
import carat_open from 'src/assets/images/carat_open.png';
import carat_closed from 'src/assets/images/carat_closed.png';
import { ButtonType } from '../Shared/Button';
import Button from '../Shared/Button/Button';
import './ProgressStep.scss';
import ContactAdvisorBanner from '../AppSell/ContactAdvisorBanner/ContactAdvisorBanner';

export interface ProgressStepProps {
  active: boolean;
  cancelLinkLabel?: string;
  className: string;
  clickable?: boolean;
  complete?: boolean;
  checkbox?: JSX.Element;
  expanded: boolean;
  nextButtonClassName?: string;
  nextButtonDisabled: boolean;
  nextButtonLabel: string | JSX.Element;
  nextButtonLoading?: boolean;
  onCancelClick?(): void;
  onClickHeader?(): void;
  onNextClick(): void;
  showCancelLink: boolean;
  step: number;
  title: JSX.Element;
  hasRas?: boolean;
  hasApp?: boolean;
}
export const ProgressStep: React.FC<ProgressStepProps> = ({
  active,
  cancelLinkLabel = 'Cancel',
  children,
  className = '',
  clickable,
  complete,
  checkbox,
  expanded,
  nextButtonClassName = '',
  nextButtonDisabled,
  nextButtonLabel,
  nextButtonLoading = false,
  onCancelClick,
  onClickHeader,
  onNextClick,
  showCancelLink,
  step,
  title,
  hasRas = false,
  hasApp = false,
}) => {
  return (
    <div
      className={classNames(
        className,
        'college-branded-progress-border',
        'progressStep',
        { 'progress-step-active': active }
      )}
    >
      <div className="progress-step-header-and-content">
        <div
          className={classNames('progress-step-header', {
            'progress-step-flat': complete,
            'progress-step-first': step === 1,
            'progress-step-pointer': clickable,
            'progress-step-notPointer': !active && !clickable,
          })}
          onClick={onClickHeader}
        >
          <div
            className={classNames(
              { dot: !complete },
              { 'dot-active': active },
              { 'dot-complete': complete }
            )}
          />
          <div
            className={classNames(
              'progress-step-number',
              {
                'progress-step-icon': complete,
              },
              { 'progress-step-completed-icon': complete }
            )}
          >
            {complete ? (
              <img
                alt="completed icon"
                className="progress-step-completed-icon"
                src={badge_completed}
              />
            ) : (
              step
            )}
          </div>
          <div
            className={classNames('progress-step-title', {
              'progress-step-title-active': active,
            })}
          >
            {title}
          </div>

          <div className="progress-step-carat">
            {(active && <img alt="section open" src={carat_open} />) ||
              (!complete && !active && (
                <img alt="section collapsed" src={carat_closed} />
              ))}
          </div>
        </div>
        {expanded && children}
      </div>
      {hasRas && active && <ContactAdvisorBanner hasApp={hasApp} />}
      {checkbox ? checkbox : null}
      {active && (
        <div className="progress-step-buttons-container">
          <Button
            buttonType={ButtonType.PRIMARY}
            className={`progress-step-next-button ${nextButtonClassName} college-branded-progress-button e2e-step-${step}-button`}
            data-testid={`step-${step}-button`}
            disabled={nextButtonDisabled}
            id={`step-${step}-button`}
            loading={nextButtonLoading}
            onClick={onNextClick}
          >
            {nextButtonLabel}
          </Button>

          {showCancelLink && (
            <button
              className="e2e-cancel progress-step-cancel-link college-branded-link"
              data-testid={`step-${step}-cancel`}
              id={`step-${step}-cancel`}
              onClick={onCancelClick}
            >
              {cancelLinkLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgressStep;
